(function () {
  function getVariantIdFromUrl() {
    try {
      const url = new URL(window.location.href);
      return url.searchParams.get("variant");
    } catch (e) {
      return null;
    }
  }

  function syncAllVariantIdInputs() {
    const variantId = getVariantIdFromUrl();
    if (!variantId) return;

    // Update every common add-to-cart variant id input
    const inputs = document.querySelectorAll(
      'form[action^="/cart/add"] input[name="id"], form[data-ajax-cart] input[name="id"], product-form-component form input[name="id"]'
    );

    inputs.forEach((input) => {
      if (input.value !== String(variantId)) {
        input.value = String(variantId);
        input.dispatchEvent(new Event("change", { bubbles: true }));
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  }

  // Run on load
  document.addEventListener("DOMContentLoaded", syncAllVariantIdInputs);

  // Watch URL changes caused by JS (pushState/replaceState)
  const _pushState = history.pushState;
  const _replaceState = history.replaceState;

  history.pushState = function () {
    const ret = _pushState.apply(this, arguments);
    window.dispatchEvent(new Event("lbj:urlchange"));
    return ret;
  };

  history.replaceState = function () {
    const ret = _replaceState.apply(this, arguments);
    window.dispatchEvent(new Event("lbj:urlchange"));
    return ret;
  };

  window.addEventListener("popstate", syncAllVariantIdInputs);
  window.addEventListener("lbj:urlchange", () => {
    // slight delay because some themes update URL then render DOM
    setTimeout(syncAllVariantIdInputs, 0);
    setTimeout(syncAllVariantIdInputs, 50);
    setTimeout(syncAllVariantIdInputs, 150);
  });

  // Also run after any change events inside variant pickers
  document.addEventListener("change", (e) => {
    const el = e.target;
    if (!el) return;
    // Only react if it looks like a product option control
    if (
      el.closest("variant-picker") ||
      el.name?.includes("options") ||
      el.getAttribute("data-option-id") ||
      el.closest("[data-variant-picker]")
    ) {
      setTimeout(syncAllVariantIdInputs, 0);
      setTimeout(syncAllVariantIdInputs, 50);
    }
  }, true);
})();
